export default __webpack_public_path__ + "static/media/Screenshot (1066).881060a1.png";